var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.4 162.7",
    style: {
      enableBackground: "new 0 0 171.4 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#f88a29;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.8,162.7c-3.2,0-6.2-1.2-8.5-3.5L3.5,109.8c-4.7-4.7-4.7-12.3-0.1-17c4.7-4.7,12.3-4.7,17-0.1l39.7,39.4  L149.6,5.1c3.8-5.4,11.3-6.7,16.7-2.9c5.4,3.8,6.7,11.3,2.9,16.7L71.6,157.6c-2,2.9-5.2,4.7-8.8,5C62.5,162.7,62.1,162.7,61.8,162.7  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.d4c216c8.svg";
export { ForwardRef as ReactComponent };